import and_still_i_rise from './img/and_still_i_rise.jpg'
import ariel from './img/ariel.png'
import call_us_what_we_carry from './img/call_us_what_we_carry.jpg'
import citizen_an_american_lyric from './img/citizen_an_american_lyric.jpg'
import crush from './img/crush.jpg'
import dont_call_us_dead from './img/dont_call_us_dead.jpeg'
import every_day_of_the_year from './img/every_day_of_the_year.jpeg'
import home_body from './img/home_body.jpeg'
import inward from './img/inward.jpeg'
import leaves_of_grass from './img/leaves_of_grass.jpg'
import magical_negro from './img/magical_negro.jpg'
import night_sky_with_exit_wounds from './img/night_sky_with_exit_wounds.jpeg'
import pillow_thoughts from './img/pillow_thoughts.png'
import rumi from './img/rumi.jpeg'
import shakespeare_sonnets_and_poems from './img/shakespeare_sonnets_and_poems.jpeg'
import soft_science from './img/soft_science.jpeg'
import the_collected_poems from './img/the_collected_poems.jpeg'
import the_complete_poetry from './img/the_complete_poetry.jpg'
import the_hill_we_climb from './img/the_hill_we_climb.jpeg'
import the_iliad from './img/the_iliad.jpg'
import the_prophet from './img/the_prophet.jpg'
import the_sun_and_her_flowers from './img/the_sun_and_her_flowers.jpg'
import the_vault from './img/the_vault.jpeg'
import the_wild_fox_of_yemen from './img/the_wild_fox_of_yemen.jpg'


export const PBookItems = [
  {
    id:1001,
    title:"And Still I Rise",
    image: and_still_i_rise,
    price:379,
    
  },
  {
    id:1002,
    title:"Ariel",
    image: ariel,
    price:949,
    
  },
  {
    id:1003,
    title:"Call Us What We Carry",
    image: call_us_what_we_carry,
    price:1979,
    
  },
  {
    id:1004,
    title:"Citizen",
    image: citizen_an_american_lyric,
    price:599,
    
  },
  {
    id:1005,
    title:"Crush",
    image: crush,
    price:629,
    
  },
  {
    id:1006,
    title:"Don't Call Us Dead",
    image: dont_call_us_dead,
    price:1299,
    
  },
  {
    id:1007,
    title:"For Every Day Of The Year",
    image: every_day_of_the_year,
    price:2999,
    
  },
  {
    id:1008,
    title:"Home Body",
    image: home_body,
    price:1299,
    
  },
  {
    id:1009,
    title:"Inward",
    image: inward,
    price:599,
    
  },
  {
    id:1010,
    title:"Leaves Of Grass",
    image: leaves_of_grass,
    price:199,
    
  },
  {
    id:1011,
    title:"Magical Negro",
    image: magical_negro,
    price:899,
    
  },
  {
    id:1012,
    title:"Night Sky With Exit Wounds",
    image: night_sky_with_exit_wounds,
    price:1099,
    
  },
  {
    id:1013,
    price:599,
    title: "Pillow Thoughts",
    image: pillow_thoughts,
    
  },
  {
    id:1014,
    price:379,
    title: "Rumi",
    image: rumi,
   
  },
  {id:1015,
    price:359,
    title: "Shakespeare's Sonnets And Poems",
    image: shakespeare_sonnets_and_poems,
    
  },
  {
    id:1016,
    price:1299,
    title: "Soft Science",
    image: soft_science,
    
  },
  {
    id:1017,
    price:299,
    title: "The Collected Poems",
    image: the_collected_poems,
    
  },
  {
    id:1018,
    price:399,
    title: "The Complete Poetry",
    image: the_complete_poetry,
    
  },
  {
    id:1019,
    price:669,
    title: "The Hill We Climb",
    image: the_hill_we_climb,
    
  },
  {
    id:1020,
    price:379,
    title: "The Iliad",
    image: the_iliad,
    
  },
  {
    id:1021,
    price:599,
    title: "The Prophet",
    image: the_prophet,
    
  },
  {
    id:1022,
    price:269,
    title: "The Sun And Her Flowers",
    image: the_sun_and_her_flowers,
    
  },
  {
    id:1023,
    price:699,
    title: "The Vault",
    image: the_vault,
    
  },
  {
    id:1024,
    price:949,
    title: "The Wild Fox Of Yemen",
    image: the_wild_fox_of_yemen,
    
  },
  
];